// extracted by mini-css-extract-plugin
export default {"container":"lB-z","dimension":"mB-z","dimensionLabels":"nB-z"};